import { Component, OnInit, input, output, signal } from '@angular/core';
import { Grouping } from 'app/classes/grouping';
import { User, UserSelection } from 'app/classes/user';
import { APIService } from 'app/shared/api.service';
import { OrgService } from 'app/shared/org.service';

@Component({
  selector: 'app-dialog-group',
  templateUrl: './dialog-group.component.html',
  styleUrls: ['./dialog-group.component.css'],
  standalone: false
})
export class DialogGroupComponent implements OnInit {

  grouping = input.required<Grouping>();

  groupingUpdated = signal<Grouping>(null);

  usersSelected: UserSelection[];
  usersAvailable: UserSelection[];
  users: UserSelection[];
  onClose = output<boolean>();
  message = signal<string>('');

  constructor(private orgService: OrgService, private apiService: APIService) { }

  ngOnInit(): void {
    this.apiService
      .getUsersForOrg()
      .then(users => {
        this.users = users.sort((a, b) => { return a.name > b.name ? 1 : -1 }).map(u => new UserSelection(u));

        if (this.grouping()?.id) {
          //this.grouping = this.config.data;
          this.orgService.getGrouping(this.grouping().id).then(g => {
            this.groupingUpdated.set(g);
            this.processGrouping();
          });
        } else {
          this.groupingUpdated.set(new Grouping());
          this.processGrouping();
        }
      });
  }

  removeUser(user: User) {
    this.groupingUpdated().users = this.groupingUpdated().users.filter(u => u.id !== user.id).sort((a, b) => a.name < b.name ? -1 : 1);
    this.processGrouping();
  }

  addUser(user: User) {
    if (this.groupingUpdated().users.findIndex(u => u.id === user.id) === -1) {
      this.groupingUpdated().users.push(user);
      this.groupingUpdated().users = this.groupingUpdated().users.sort((a, b) => a.name < b.name ? -1 : 1);
      this.processGrouping();
    }
  }

  processGrouping() {
    this.usersAvailable = this.users.filter(u => this.groupingUpdated().users.findIndex(gu => gu.id === u.id) === -1);
  }

  cancel() {
    this.onClose.emit(true);
  }

  async submit() {

    if (!(this.groupingUpdated().title?.length > 0) || this.groupingUpdated().users?.length === 0) {
      this.message.set('Title and users in group required.');
      return;
    }

    await this.orgService.updateGrouping(this.groupingUpdated());
    this.apiService.toastSuccess('updated');
    this.onClose.emit(true);
  }

}
